export const messages = {
    en: {
        buildingBrowseManage: {
            search: {
                title: 'Building Browse Records Query',
                buildingName: 'Building Name',
                userName: 'User Name'
            },
            list: {
                title: 'Building Browse Records List'
            },
            table: {
                id: 'ID',
                buildingName: 'Building Name',
                userName: 'User Name',
                userTel: 'User Tel',
                createTime: 'Create Time',
                statusCd: 'Status'
            },
            view: {
                title: 'View Building Browse Record'
            },
            delete: {
                title: 'Delete Building Browse Record',
                confirmMessage: 'Are you sure you want to delete this record?'
            },
            form: {
                buildingName: 'Building Name',
                buildingNamePlaceholder: 'Please enter building name',
                userName: 'User Name',
                userNamePlaceholder: 'Please enter user name',
                userTel: 'User Tel',
                userTelPlaceholder: 'Please enter user tel',
                createTime: 'Create Time',
                createTimePlaceholder: 'Please select create time',
                statusCd: 'Status',
                statusCdPlaceholder: 'Please select status'
            },
            statusCdOptions: {
                normal: 'Normal',
                disabled: 'Disabled'
            }
        }
    },
    zh: {
        buildingBrowseManage: {
            search: {
                title: '房产浏览记录查询',
                buildingName: '房产名称',
                userName: '用户名称'
            },
            list: {
                title: '房产浏览记录列表'
            },
            table: {
                id: 'ID',
                buildingName: '房产名称',
                userName: '用户名称',
                userTel: '用户电话',
                createTime: '创建时间',
                statusCd: '状态'
            },
            view: {
                title: '查看房产浏览记录'
            },
            delete: {
                title: '删除房产浏览记录',
                confirmMessage: '确定要删除这条记录吗？'
            },
            form: {
                buildingName: '房产名称',
                buildingNamePlaceholder: '请输入房产名称',
                userName: '用户名称',
                userNamePlaceholder: '请输入用户名称',
                userTel: '用户电话',
                userTelPlaceholder: '请输入用户电话',
                createTime: '创建时间',
                createTimePlaceholder: '请选择创建时间',
                statusCd: '状态',
                statusCdPlaceholder: '请选择状态'
            },
            statusCdOptions: {
                normal: '正常',
                disabled: '禁用'
            }
        }
    }
}